module.exports = __webpack_public_path__ + "img/03.c7caffc3.png";